// import { FunctionComponent, useEffect } from "react";
// import { motion } from "framer-motion";
// import styles from "./section3.module.css";

// const cardData = [
//   {
//     title: "Customized dashboard to find",
//     description: "accurate insights ok just making this to 3 lines",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "AI-powered analytics",
//     description: "Improve insights with real-time data.",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "Automated follow-ups",
//     description: "Increase efficiency with smart reminders.",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "Smart risk assessment",
//     description: "Identify high-risk accounts proactively.",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "Data-driven strategies",
//     description: "Enhance recovery rates with predictive insights.",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "Seamless integrations",
//     description: "Connect with existing financial tools effortlessly.",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "Seamless integrations",
//     description: "Connect with existing financial tools effortlessly.",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "Seamless integrations",
//     description: "Connect with existing financial tools effortlessly.",
//     image: "./assets/collection1.png",
//   },

// ];

// const staggerVariants = {
// 	hidden: (i: number) => ({
// 	  opacity: 0,
// 	  x: i % 2 === 0 ? -50 : 50, // Moves left for even indexes, right for odd
// 	}),
// 	visible: (i: number) => ({
// 	  opacity: 1,
// 	  x: 0,
// 	  transition: { delay: i * 0.2, type: "spring", stiffness: 100 },
// 	}),
//   };


// const Section3: FunctionComponent = () => {
// 	useEffect(() => {
//     function animateCards() {
//       const cards = document.querySelectorAll(`.${styles.component2Parent}`);
//       cards.forEach((card, index) => {
//         (card as HTMLElement).style.opacity = "1";
//         (card as HTMLElement).style.transform = "translateX(0)";
//         (card as HTMLElement).style.transition = `opacity 0.6s ease ${index * 0.2}s, transform 0.6s ease ${index * 0.2}s`;
//       });
//     }

//     function observeSections() {
//       const target = document.querySelector(`.${styles.solvingDebtRecoveryChallengParent}`);
//       if (!target) return;

//       const observer = new IntersectionObserver(
//         (entries) => {
//           entries.forEach((entry) => {
//             if (entry.isIntersecting) {
//               animateCards();
//               observer.disconnect(); // Stop observing once triggered
//             }
//           });
//         },
//         { threshold: 0.3 }
//       );

//       observer.observe(target);
//     }

//     observeSections();
//   }, []);
//   return (
//     <div className={styles.solvingDebtRecoveryChallengParent}>
//       <div className={styles.solvingDebtRecovery}>Solving Debt Recovery Challenges</div>
//       <div className={styles.groupWrapper}>
//         <div className={styles.subtractParent}>
//           <div className={styles.nounFlyingMoneybag60394501}>
//             <div className={styles.ellipseDiv} />
//             <div className={styles.ellipseDiv} />
//             <img className={styles.vectorIcon} alt="" src="./assets/vector.png" />
//           </div>
//           {cardData.map((card, index) => (
//             <motion.div
//               key={index}
//               className={styles[`component2Parent${index}`] || styles.component2Parent}
//               initial="hidden"
//               animate="visible"
//               custom={index}
//               variants={staggerVariants}
//             >
//               <img className={styles.component2Icon} alt="" src={card.image} />
//               <div className={styles.customizedDashboardToContainer}>
//                 <span className={styles.customizedDashboardToContainer1}>
//                   <p className={styles.customizedDashboardTo}>{card.title}</p>
//                   <p className={styles.customizedDashboardTo}>{card.description}</p>
//                 </span>
//               </div>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Section3;
// import { FunctionComponent, useEffect } from "react";
// import { motion } from "framer-motion";
// import styles from "./section3.module.css";

// const cardData = [
//   {
//     title: "Customized dashboard to find",
//     description: "accurate insights ok just making this to 3 lines",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "AI-powered analytics",
//     description: "Improve insights with real-time data.",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "Automated follow-ups",
//     description: "Increase efficiency with smart reminders.",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "Smart risk assessment",
//     description: "Identify high-risk accounts proactively.",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "Data-driven strategies",
//     description: "Enhance recovery rates with predictive insights.",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "Seamless integrations",
//     description: "Connect with existing financial tools effortlessly.",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "Data-driven strategies",
//     description: "Enhance recovery rates with predictive insights.",
//     image: "./assets/collection1.png",
//   },
//   {
//     title: "Data-driven strategies",
//     description: "Enhance recovery rates with predictive insights.",
//     image: "./assets/collection1.png",
//   },
// ];

// const staggerVariants = {
//   hidden: (i: number) => ({
//     opacity: 0,
//     x: i % 2 === 0 ? -50 : 50, // Moves left for even indexes, right for odd
//   }),
//   visible: (i: number) => ({
//     opacity: 1,
//     x: 0,
//     transition: { delay: i * 0.2, type: "spring", stiffness: 100 },
//   }),
// };

// const Section3: FunctionComponent = () => {
//  	useEffect(() => {
//     function animateCards() {
//       const cards = document.querySelectorAll(`.${styles.component2Parent}`);
//       cards.forEach((card, index) => {
//         (card as HTMLElement).style.opacity = "1";
//         (card as HTMLElement).style.transform = "translateX(0)";
//         (card as HTMLElement).style.transition = `opacity 0.6s ease ${index * 0.2}s, transform 0.6s ease ${index * 0.2}s`;
//       });
//     }

//     function observeSections() {
//       const target = document.querySelector(`.${styles.solvingDebtRecoveryChallengParent}`);
//       if (!target) return;

//       const observer = new IntersectionObserver(
//         (entries) => {
//           entries.forEach((entry) => {
//             if (entry.isIntersecting) {
//               animateCards();
//               observer.disconnect();
//             }
//           });
//         },
//         { threshold: 0.3 }
//       );

//       observer.observe(target);
//     }

//     observeSections();
//   }, []);

//   return (
//     <div className={styles.solvingDebtRecoveryChallengParent}>
//       <div className={styles.solvingDebtRecovery}>Solving Debt Recovery Challenges</div>
//       <div className={styles.groupWrapper}>
//         <div className={styles.subtractParent}>
//           <div className={styles.nounFlyingMoneybag60394501}>
//             <div className={styles.ellipseDiv} />
//             <div className={styles.ellipseDiv} />
//             <img className={styles.vectorIcon} alt="" src="./assets/vector.png" />
//           </div>
//           {cardData.map((card, index) => (
//             <motion.div
//               key={index}
// 			  className={styles[`component2Parent${index}`] || styles.component2Parent}
//               initial="hidden"
// 			   animate="visible"
//               variants={staggerVariants}
//               custom={index}
//             >
//               <img className={styles.component2Icon} alt="" src={card.image} />
//               <div className={styles.customizedDashboardToContainer}>
//                 <span className={styles.customizedDashboardToContainer1}>
//                   <p className={styles.customizedDashboardTo}>{card.title}</p>
//                   <p className={styles.customizedDashboardTo}>{card.description}</p>
//                 </span>
//               </div>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Section3;
import { FunctionComponent } from "react";
import { motion, useInView } from "framer-motion";
import styles from "./section3.module.css";
import { useRef } from "react";
import { Cover } from "../AceternityUI/3D-cardEffect/cover";

const cardData = [
  {
    title: "Your dashboards don't show the full lifecycle of a delinquent account.",

    image: "./assets/collection1.png",
  },
  {
    title: "You're juggling multiple systems that don't talk to each other.",

    image: "./assets/collection1.png",
  },
  {
    title: "Getting a clear view of your collection performance takes weeks.",

    image: "./assets/collection1.png",
  },
  {
    title: "Your collection strategies are static and lack personalization.",

    image: "./assets/collection1.png",
  },
  {
    title: "Your agents are overwhelmed, and your customers are irritated.",

    image: "./assets/collection1.png",
  },
  {
    title: "You're often making decisions based on outdated information.",

    image: "./assets/collection1.png",
  },
  {
    title: "Your compliance checks are manual, time-consuming, and prone to errors.",

    image: "./assets/collection1.png",
  },
  {
    title: "You need IT help every time you want to tweak your collection strategy.",
    image: "./assets/collection1.png",
  },
];

const staggerVariants = {
  hidden: (i: number) => ({
    opacity: 0,
    x: i % 2 === 0 ? -50 : 50,
  }),
  visible: (i: number) => ({
    opacity: 1,
    x: 0,
    transition: { delay: i * 0.2, type: "spring", stiffness: 100 },
  }),
};

const Section3: FunctionComponent = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: 0.3, once: false });

  return (
    <div ref={ref} className={styles.solvingDebtRecoveryChallengParent} >
      <div className={styles.solvingDebtRecovery}>Solving Debt <Cover /> Challenges</div>

      <div className={styles.groupWrapper}>
        <div className={styles.subtractParent}>
          <div className={styles.nounFlyingMoneybag60394501}>
            <div className={styles.ellipseDiv} />
            <div className={styles.ellipseDiv} />
            <img className={styles.vectorIcon} alt="" src="./assets/vector.png" />
          </div>
          {cardData.map((card, index) => (
            <motion.div
              key={index}
              className={`${styles[`component2Parent${index}`] || styles.component2Parent} ${
                card.title.includes("incomplete or outdated information") ? styles.specialCard : ""
              }`}              
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
              variants={staggerVariants}
              custom={index}
            >
              <img className={styles.component2Icon} alt="" src={card.image} />
              <div className={styles.customizedDashboardToContainer}>
                <span className={styles.customizedDashboardToContainer1}>
                  <p className={styles.customizedDashboardTo}>{card.title}</p>
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Section3;
